(function ($) {
    "use strict";

    /* ===== 1. Preloader Handling ===== */
    $(document).on("turbo:load", function () {
        $("#preloader").css("display", "none");
    });

    $(document).on("turbo:before-visit", function () {
        $("#preloader").css("display", "flex");
    });

    $(document).ready(function () {
        $("#preloader").css("display", "none");
    });

    /* ===== 2. Navbar Scroll Effect ===== */
    $(window).on("scroll", function () {
        var $navbar = $(".navbar");
        if ($(window).scrollTop() > 50) {
            $navbar.addClass("scrolled");
        } else {
            $navbar.removeClass("scrolled");
        }
    });

    /* ===== Auto Close Mobile Navbar ===== */
    function initMobileNavbar() {
        // Get the collapse element
        const navbarCollapse = document.querySelector(".navbar-collapse");
        const navbarToggler = document.querySelector(".navbar-toggler");

        // Add click event to all navbar links
        const navLinks = document.querySelectorAll(".navbar-nav .nav-link");
        navLinks.forEach((link) => {
            link.addEventListener("click", () => {
                // Skip if this is a dropdown toggle
                if (link.classList.contains("dropdown-toggle")) {
                    return;
                }

                // Check if navbar is expanded (mobile view)
                if (navbarToggler.getAttribute("aria-expanded") === "true") {
                    // Close the navbar
                    const bsCollapse = new bootstrap.Collapse(navbarCollapse, {
                        toggle: false,
                    });
                    bsCollapse.hide();

                    // Update toggler state
                    navbarToggler.setAttribute("aria-expanded", "false");
                    navbarToggler.classList.add("collapsed");
                }
            });
        });

        // Add click event to dropdown items
        const dropdownItems = document.querySelectorAll(".dropdown-item");
        dropdownItems.forEach((item) => {
            item.addEventListener("click", () => {
                if (navbarToggler.getAttribute("aria-expanded") === "true") {
                    // Close the navbar
                    const bsCollapse = new bootstrap.Collapse(navbarCollapse, {
                        toggle: false,
                    });
                    bsCollapse.hide();

                    // Update toggler state
                    navbarToggler.setAttribute("aria-expanded", "false");
                    navbarToggler.classList.add("collapsed");
                }
            });
        });
    }

    /* ===== 3. Utility Functions ===== */
    function cleanupModal() {
        if (!$(".modal.show").length) {
            $("body").removeClass("modal-open").css({
                overflow: "",
                "padding-right": "",
            });
            $(".modal-backdrop").remove();
        }
    }

    function closeAllModals() {
        $(".modal.show").each(function () {
            const modalInstance = bootstrap.Modal.getInstance(this);
            if (modalInstance) {
                modalInstance.hide();
            }
        });

        cleanupModal();
    }

    function displayError(errorElement, message) {
        const $errorElement = $(errorElement); // Konversi elemen ke objek jQuery
        $errorElement.text(message).show();
    }

    function clearError(errorElement) {
        const $errorElement = $(errorElement); // Konversi elemen ke objek jQuery
        $errorElement.hide().text("");
    }

    function trackNavigation() {
        const currentPath = window.location.pathname; // URL halaman saat ini
        let history =
            JSON.parse(sessionStorage.getItem("navigationHistory")) || [];

        // Jika halaman saat ini berbeda dari halaman terakhir dalam riwayat, tambahkan ke riwayat
        if (history[history.length - 1] !== currentPath) {
            history.push(currentPath);
            sessionStorage.setItem(
                "navigationHistory",
                JSON.stringify(history)
            );
        }
    }

    function initBackButton() {
        const $backButton = $("#back-button");

        if ($backButton.length) {
            $backButton.on("click", function () {
                let history =
                    JSON.parse(sessionStorage.getItem("navigationHistory")) ||
                    [];

                if (history.length > 1) {
                    // Hapus halaman saat ini dari riwayat
                    history.pop();
                    sessionStorage.setItem(
                        "navigationHistory",
                        JSON.stringify(history)
                    );

                    // Navigasi ke halaman sebelumnya
                    const previousPage = history[history.length - 1];
                    window.location.href = previousPage;
                } else {
                    // Jika tidak ada riwayat, navigasi ke home
                    window.location.href = "/";
                }
            });
        }
    }

    function clearNavigationHistoryOnEntry() {
        const excludedPaths = ["/login", "/register"];
        const currentPath = window.location.pathname;

        if (excludedPaths.includes(currentPath)) {
            sessionStorage.removeItem("navigationHistory");
        }
    }

    function updateSeatCounter(remainingSeats) {
        $(".seat-number").text(remainingSeats);
    }

    /* ===== 4. Event Handlers ===== */
    function handlePackageSelect(button) {
        selectedPackage = {
            type: $(button).data("package"),
            price: $(button).data("price"),
        };
        var isLoggedIn = false;
        cleanupModal();
        if (isLoggedIn) {
            var signupModal = new bootstrap.Modal($("#signupModal")[0]);
            signupModal.show();
        } else {
            var loginModal = new bootstrap.Modal($("#loginModal")[0]);
            loginModal.show();
        }
    }

    function handleSponsorSelect(button) {
        selectedPackage = {
            type: $(button).data("package"),
            price: $(button).data("price"),
            isSponsorship: true,
        };
        var isLoggedIn = false;
        cleanupModal();
        if (isLoggedIn) {
            var signupModal = new bootstrap.Modal($("#signupModal")[0]);
            signupModal.show();
        } else {
            var loginModal = new bootstrap.Modal($("#loginModal")[0]);
            loginModal.show();
        }
    }

    function handleSponsorWhatsApp(packageType, price) {
        var phoneNumber = "6281267560600";
        var message =
            "Hi, I'm interested in becoming a " +
            packageType.toUpperCase() +
            " sponsor for SHIFT in BALI ($" +
            price +
            ")";
        var whatsappUrl =
            "https://wa.me/" +
            phoneNumber +
            "?text=" +
            encodeURIComponent(message);
        window.open(whatsappUrl, "_blank");
    }

    function markSeatAsBooked(seatElement) {
        var $seat = $(seatElement);
        if ($seat.hasClass("available")) {
            $seat.removeClass("available").addClass("booked");
            var currentCount = parseInt($(".seat-number").text(), 10);
            updateSeatCounter(currentCount - 1);
        }
    }

    /* ===== 5. Signup Form Module ===== */
    var SignupForm = (function () {
        var formData = {
            name: "",
            email: "",
            phone: "",
            company: "",
            accountType: "local",
            password: "",
        };

        // var currentStep = 1;

        // Password Strength Check Function
        function checkPasswordStrength(password) {
            let strength = 0;
            if (password.length >= 8) strength += 25;
            if (password.match(/[a-z]+/)) strength += 25;
            if (password.match(/[A-Z]+/)) strength += 25;
            if (password.match(/[0-9]+/)) strength += 25;
            return strength;
        }

        // Update Password Strength Display
        function updatePasswordStrength(strength, $bar, $text) {
            let color = "";
            let message = "";

            if (strength <= 25) {
                color = "#dc3545";
                message = "Very Weak";
            } else if (strength <= 50) {
                color = "#ffc107";
                message = "Weak";
            } else if (strength <= 75) {
                color = "#0dcaf0";
                message = "Medium";
            } else {
                color = "#198754";
                message = "Strong";
            }

            $bar.css({
                width: `${strength}%`,
                backgroundColor: color,
            });
            $text.text(message);
        }

        // Reset Password Strength Display
        // function resetPasswordStrength($bar, $text) {
        //     $bar.css({
        //         width: "0%",
        //         backgroundColor: "#dc3545",
        //     });
        //     $text.text("Very Weak");
        // }

        function checkUniqueField(field, value) {
            return $.ajax({
                url: "/user/verify-field",
                type: "POST",
                data: {
                    field: field,
                    value: value,
                    _token: $("meta[name='csrf-token']").attr("content"),
                },
                dataType: "json",
            });
        }

        function displayErrorMessages(errorMessages) {
            var $alertDiv = $("#signupModal .alert");
            if (!$alertDiv.length) {
                $alertDiv = $(
                    '<div class="alert alert-danger"><ul class="mb-0">' +
                        errorMessages +
                        "</ul></div>"
                );
                $("#signupForm").prepend($alertDiv);
            } else {
                $alertDiv
                    .html('<ul class="mb-0">' + errorMessages + "</ul>")
                    .removeClass("d-none");
            }
        }

        function hideErrorMessages() {
            var $alertDiv = $("#signupModal .alert");
            if ($alertDiv.length) {
                $alertDiv.addClass("d-none");
            }
        }

        function removeFieldError(inputId) {
            $(inputId).removeClass("is-invalid");
            $(inputId).closest(".mb-3").find(".error-message").remove();
        }

        // Email Format Validation
        function isValidEmail(email) {
            var emailPattern =
                /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
            return emailPattern.test(email);
        }

        // Phone Number Validation
        function isValidPhoneNumber(phone) {
            var cleanPhone = phone.replace(/\D/g, "");
            return /^\d{10,}$/.test(cleanPhone);
        }

        // Next Step Logic
        function nextStep(step) {
            var $currentStepEl = $("#step" + step);
            var $inputs = $currentStepEl.find("input[required]");
            var isValid = true;

            $inputs.each(function () {
                if (!$(this).val().trim()) {
                    isValid = false;
                    displayErrorMessages("<li>All fields are required.</li>");
                } else {
                    removeFieldError(this);
                }
            });

            if (!isValid) return;

            if (step === 1) {
                var name = $("#signupName").val().trim();
                var email = $("#signupEmail").val().trim();

                // Email format validation
                if (!isValidEmail(email)) {
                    displayErrorMessages(
                        "<li>Please enter a valid email address.</li>"
                    );
                    return;
                }

                checkUniqueField("email", email)
                    .done(function (response) {
                        if (response.exists) {
                            displayErrorMessages(
                                "<li>Email address is already registered!</li>"
                            );
                            return;
                        }

                        formData.name = name;
                        formData.email = email;

                        // Proceed to next step
                        $currentStepEl.hide();
                        $("#step" + (step + 1)).show();
                        updateProgressBar(step + 1);
                        currentStep = step + 1;

                        // Hide error messages if the user is moving to the next step
                        hideErrorMessages();
                    })
                    .fail(function () {
                        displayErrorMessages(
                            "<li>Server error occurred while checking email uniqueness.</li>"
                        );
                    });
            } else if (step === 2) {
                var phone = $("#signupPhone").val().trim();
                var company = $("#signupCompany").val().trim();
                var accountType = $("#signupAccountType").val();

                // Phone number format validation
                if (!isValidPhoneNumber(phone)) {
                    displayErrorMessages(
                        "<li>Phone number must contain at least 10 digits.</li>"
                    );
                    return;
                }

                checkUniqueField("phone_number", phone)
                    .done(function (response) {
                        if (response.exists) {
                            displayErrorMessages(
                                "<li>Phone number is already registered!</li>"
                            );
                            return;
                        }

                        formData.phone = phone;
                        formData.company = company;
                        formData.accountType = accountType;

                        // Proceed to next step
                        $currentStepEl.hide();
                        $("#step" + (step + 1)).show();
                        updateProgressBar(step + 1);
                        currentStep = step + 1;

                        // Hide error messages if the user is moving to the next step
                        hideErrorMessages();
                    })
                    .fail(function () {
                        displayErrorMessages(
                            "<li>Server error occurred while checking phone number uniqueness.</li>"
                        );
                    });
            }
        }

        function prevStep(step) {
            $("#step" + step).hide();
            $("#step" + (step - 1)).show();
            updateProgressBar(step - 1);
            currentStep = step - 1;
        }

        function updateProgressBar(step) {
            var $progressBar = $(".progress-bar");
            $progressBar
                .css("width", step * 33.33 + "%")
                .attr("aria-valuenow", step * 33.33);
        }

        function handleFormSubmission(e) {
            e.preventDefault();

            var $singUpForm = $(this);

            // Validate password confirmation
            var password = $("#signupPassword").val();
            var confirmPassword = $("#confirmPassword").val();
            if (password !== confirmPassword) {
                displayErrorMessages("<li>Passwords do not match.</li>");
                return;
            }
            formData.password = password;
            hideErrorMessages();

            $.ajax({
                url: $singUpForm.attr("action"),
                type: "POST",
                data: {
                    name: formData.name,
                    email: formData.email,
                    phone_number: formData.phone,
                    company_name: formData.company,
                    account_type: formData.accountType,
                    password: formData.password,
                    _token: $("meta[name='csrf-token']").attr("content"),
                },
                dataType: "json",
                success: function (response) {
                    if (response.redirect) {
                        window.location.href = response.redirect;
                    } else {
                        var signupModal = bootstrap.Modal.getInstance(
                            $("#signupModal")[0]
                        );
                        signupModal.hide();
                        cleanupModal();
                    }
                },
                error: function (err) {
                    var errorMessages = "";
                    if (err.status === 422 && err.responseJSON.errors) {
                        $.each(
                            err.responseJSON.errors,
                            function (key, messages) {
                                $.each(messages, function (i, message) {
                                    errorMessages += "<li>" + message + "</li>";
                                });
                            }
                        );
                    } else {
                        errorMessages =
                            "<li>An unexpected error occurred. Please try again.</li>";
                    }
                    displayErrorMessages(errorMessages);
                },
            });
        }

        // Initialize Event Bindings
        function initEventBindings() {
            $(".next-step").on("click", function () {
                var step = parseInt($(this).data("step"), 10);
                nextStep(step);
            });

            $(".prev-step").on("click", function () {
                var step = parseInt($(this).data("step"), 10);
                prevStep(step);
            });

            $("#signupForm input[required]").on("input", function () {
                removeFieldError(this);
            });

            // Toggle visibility password
            $(".toggle-password").on("click", function () {
                const targetId = $(this).data("target");
                const $input = $(`#${targetId}`);
                const type =
                    $input.attr("type") === "password" ? "text" : "password";
                $input.attr("type", type);
                $(this).find("i").toggleClass("fa-eye fa-eye-slash");
            });

            // Check password strength
            $("#signupPassword").on("input", function () {
                var password = $(this).val();
                var strength = checkPasswordStrength(password);
                var $progressBar = $("#passwordStrengthBar");
                var $strengthText = $("#passwordStrengthText");
                updatePasswordStrength(strength, $progressBar, $strengthText);
            });
            $("#signupForm").on("submit", handleFormSubmission);
        }

        return {
            init: function () {
                initEventBindings();
            },
        };
    })();

    /* ===== 6. Login Form Handling ===== */
    var LoginForm = (function () {
        function handleLoginSubmission(e) {
            e.preventDefault();

            var $loginForm = $(this);

            var formData = {
                email: $loginForm.find('input[name="email"]').val(),
                password: $loginForm.find('input[name="password"]').val(),
                remember: $loginForm
                    .find('input[name="remember"]')
                    .is(":checked"),
            };

            $.ajax({
                url: $loginForm.attr("action"),
                method: "POST",
                contentType: "application/json",
                dataType: "json",
                data: JSON.stringify(formData),
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                },
                xhrFields: {
                    withCredentials: true,
                },
                success: function (response) {
                    if (response.redirect) {
                        window.location.href = response.redirect;
                    } else {
                        var loginModal = bootstrap.Modal.getInstance(
                            $("#loginModal")[0]
                        );
                        loginModal.hide();
                        cleanupModal();
                    }
                },
                error: function (jqXHR) {
                    var errorMessages = "";

                    if (
                        jqXHR.status === 422 &&
                        jqXHR.responseJSON &&
                        jqXHR.responseJSON.errors
                    ) {
                        $.each(
                            jqXHR.responseJSON.errors,
                            function (key, messages) {
                                $.each(messages, function (i, message) {
                                    errorMessages += "<li>" + message + "</li>";
                                });
                            }
                        );
                    } else if (
                        jqXHR.responseJSON &&
                        jqXHR.responseJSON.message
                    ) {
                        errorMessages =
                            "<li>" + jqXHR.responseJSON.message + "</li>";
                    } else {
                        errorMessages =
                            "<li>An unexpected error occurred. Please try again.</li>";
                    }

                    var $alertDiv = $("#loginModal .alert");
                    if (!$alertDiv.length) {
                        $alertDiv = $(
                            '<div class="alert alert-danger"><ul class="mb-0">' +
                                errorMessages +
                                "</ul></div>"
                        );
                        $loginForm.prepend($alertDiv);
                    } else {
                        $alertDiv
                            .html('<ul class="mb-0">' + errorMessages + "</ul>")
                            .removeClass("d-none");
                    }
                },
            });
        }

        function initEventBindings() {
            var $loginForm = $("#loginForm");
            if ($loginForm.length) {
                $loginForm.off("submit");
                $loginForm.on("submit", handleLoginSubmission);
            }
        }

        return {
            init: function () {
                initEventBindings();
            },
        };
    })();

    /* ===== 8. Modal ===== */
    function cleanModalCls() {
        $(document).on("show.bs.modal", function () {
            // $(".navbar.fixed-top").removeClass("fixed-top");
        });

        $(document).on("hidden.bs.modal", function () {
            // $(".navbar").addClass("fixed-top");
        });
    }

    /* ===== 10. Seat Booking ===== */
    function initSeatBooking() {
        $(".seat.available").on("click", function () {
            markSeatAsBooked(this);
        });
    }

    /* ===== 11. Window Load Event ===== */
    function handleWindowLoad() {
        $(window).on("load", function () {
            var $preloader = $("#preloader");
            if ($preloader.length) {
                setTimeout(function () {
                    $preloader.css("opacity", "0");
                    setTimeout(function () {
                        $preloader.css("display", "none");
                    }, 500);
                }, 1000);
            }
        });
    }

    /* ===== 12. Toast Hanlder ===== */
    function showToast(message, type = "success") {
        const $notificationToast = $("#notificationToast");
        const toastMessageElement = $notificationToast.find(".toast-message");
        const iconClass =
            type === "success" ? "fa-check-circle" : "fa-exclamation-circle";
        const bgClass = type === "success" ? "bg-success" : "bg-danger";

        $notificationToast
            .removeClass("bg-success bg-danger")
            .addClass(bgClass);
        $notificationToast
            .find(".toast-icon")
            .removeClass("fa-check-circle fa-exclamation-circle")
            .addClass(iconClass);
        toastMessageElement.text(message);

        const toastInstance = new bootstrap.Toast($notificationToast[0]);
        toastInstance.show();
    }

    /* ===== 13. Loading Overlay ===== */
    const loadingOverlay = document.getElementById("loadingOverlay");

    function showLoadingOverlay() {
        loadingOverlay.style.display = "block";
    }

    function hideLoadingOverlay() {
        loadingOverlay.style.display = "none";
    }

    /* ===== 14. Listen Email Succes ===== */
    function cleanQueryString() {
        const url = new URL(window.location);
        url.searchParams.delete("verified");
        window.history.pushState({}, "", url);
    }

    if (window.location.search.includes("?verified=1")) {
        showToast("Email verified successfully!", "success");
        cleanQueryString();
    }

    /* ===== Expose Utility Functions Globally ===== */
    window.clearError = clearError;
    window.displayError = displayError;
    window.closeAllModals = closeAllModals;
    window.handlePackageSelect = handlePackageSelect;
    window.handleSponsorSelect = handleSponsorSelect;
    window.handleSponsorWhatsApp = handleSponsorWhatsApp;
    window.markSeatAsBooked = markSeatAsBooked;
    window.showToast = showToast;
    window.showLoadingOverlay = showLoadingOverlay;
    window.hideLoadingOverlay = hideLoadingOverlay;

    /* ===== Initialize All Modules ===== */
    $(document).ready(function () {
        SignupForm.init();
        LoginForm.init();
        cleanModalCls();
        trackNavigation();
        initBackButton();
        clearNavigationHistoryOnEntry();
        initSeatBooking();
        handleWindowLoad();
        initMobileNavbar();
    });
})(jQuery);
